import { Skeleton, Row, Col } from 'antd';
import { FormItem, generateSlugify, Input } from 'asumsi-components';
import React from "react";
import SunEditor from 'suneditor-react';

export const PageEditorPostFormComponent = (props: any) => {

    // declare action and attribute needed
    const { isLoader, fieldsValues, setFieldsValues, setContent } = props;

    const onChangeContent = (value: any) => {
        // get text only from html string
        let plainText = value.replace(/<[^>]+>/g, '');

        // validation on title, slug and topic field must not null
        const errors = fieldsValues.errors ? fieldsValues.errors : [];
        if (errors.length < 1) {
            if(plainText.length > 50){
                // do postData here
            }
        }
        
        setContent(value)
    }

    const onChangeTitle = (e: any) => {
        const val: string = e.target.value;
        const slug = generateSlugify(val);
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'slug');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }

        if (!slug) {
            errors.push('slug');
        }
        
        if (!fieldsValues.topicId && errors.findIndex((element: string) => element == 'topicId')) {
            errors.push('topicId');
        }

        setFieldsValues({ ...fieldsValues, errors, slug });
        
        // do postData here
    }

    // return JSX Element 
    return (
        <div>
            <Skeleton loading={isLoader}>
                <Row gutter={30}>
                    <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                        <Row>
                            <Col span={24}>
                                <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Title" labelAlign="left"
                                    fieldDecorator={{
                                        label: "title",
                                        rules: [{
                                            message: 'Please input title',
                                            required: true,
                                        }
                                        ]
                                    }}
                                >
                                    <Input id="title" defaultValue={fieldsValues.title} onChange={onChangeTitle} />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <FormItem setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Content" labelAlign="left"
                                    fieldDecorator={{
                                        label: "content"
                                    }}
                                >
                                    <SunEditor setContents={fieldsValues.content} onChange={onChangeContent} height="280px" enableToolbar={true} setOptions={{
                                        resizingBar: false,
                                        mode: "classic",
                                        font: ['Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'IBM Plex Serif', 'Impact', 'Inter', 'tahoma', 'Trebuchet MS', 'Verdana'],
                                        katex: "window.katex",
                                        imageGalleryUrl: "https://etyswjpn79.execute-api.ap-northeast-1.amazonaws.com/suneditor-demo",
                                        buttonList: [
                                            [
                                                "undo",
                                                "redo",
                                                "font",
                                                "fontSize",
                                                "formatBlock",
                                                "paragraphStyle",
                                                "blockquote",
                                                "bold",
                                                "underline",
                                                "italic",
                                                "strike",
                                                "subscript",
                                                "superscript",
                                                "fontColor",
                                                "hiliteColor",
                                                "textStyle",
                                                "removeFormat",
                                                "outdent",
                                                "indent",
                                                "align",
                                                "horizontalRule",
                                                "list",
                                                "lineHeight",
                                                "table",
                                                "link",
                                                "image",
                                                "video",
                                                "audio",
                                                "math",
                                                "imageGallery",
                                                "fullScreen",
                                                "showBlocks",
                                                "codeView",
                                                "preview",
                                                "print",
                                                "save"
                                            ]
                                        ],
                                    }} />
                                </FormItem>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Skeleton>
        </div>
    );
};
export default PageEditorPostFormComponent;



// WEBPACK FOOTER //
// ./src/pages/post-form/libraries/editor.tsx